import * as React from "react";
import {
  Grid,
  Typography,
  Paper,
  Divider,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@material-ui/core";
import RoomIcon from "@material-ui/icons/Room";

interface IProps {
  placeOfService: string;
  onPlaceOfServiceChange: (value: string) => void;
}

const PlaceOfServiceSelector: React.FC<IProps> = ({
  placeOfService,
  onPlaceOfServiceChange,
}) => {
  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    onPlaceOfServiceChange(event.target.value as string);
  };

  return (
    <Grid item xs={12}>
      <Paper
        style={{ padding: 24, backgroundColor: "#e3f2fd", borderRadius: 8 }}
      >
        <Typography
          variant="h6"
          gutterBottom
          style={{
            color: "black",
            fontWeight: 600,
            display: "flex",
            alignItems: "center",
            gap: 8,
          }}
        >
          <RoomIcon style={{ color: "#546e7a" }} />
          Place of Service
        </Typography>
        <Typography
          variant="caption"
          color="textSecondary"
          style={{ display: "block", marginBottom: 16 }}
        >
          Kiosk Configuration
        </Typography>
        <Divider style={{ marginBottom: 20 }} />

        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <FormControl fullWidth variant="outlined" size="medium">
              <InputLabel>Place of Service</InputLabel>
              <Select
                value={placeOfService}
                onChange={handleChange}
                label="Place of Service"
              >
                <MenuItem value="11">11 - In-Office Appointment</MenuItem>
                <MenuItem value="10">10 - Remote Appointment</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={8}>
            <Paper
              style={{
                padding: 16,
                backgroundColor: "#ffffff",
                borderLeft: "4px solid #546e7a",
              }}
            >
              <Typography
                variant="caption"
                color="textSecondary"
                display="block"
                gutterBottom
              >
                Configuration Note
              </Typography>
              <Typography variant="body2" style={{ lineHeight: 1.6 }}>
                • <strong>11 (In-Office)</strong> - Makes prescription kiosk
                eligible
                <br />• <strong>10 (Remote)</strong> - Remote appointment
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  );
};

export default PlaceOfServiceSelector;
